import React, { useEffect, useState } from 'react'
import { Label } from 'reactstrap'
import DatePicker from "react-datepicker";
import moment from 'moment';
import { CalenderIcon } from '../../Icon';
import Select from 'react-select';
import { components } from 'react-select';
import { CircularAvatar } from '../../commons';
import "./lead.scss"
import { SelctOptionType } from '../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm';
import { LoginResponseType } from '../../../redux/auth/authTypes';

type AppProps = {
    leadInfo: any;
    finalUserList: any;
    setLeadInfoDetails: any;
    limit: number;
    fetching: boolean;
    setText: (data: string) => void;
    setoffset: any;
    handleLeadInfoDetailsChange: (data: any) => void;
    handleLeadAssignedToChange: (data: any) => void;
    handleDemoAssignedToChange: (data: any) => void;
    handleLeadReceivedOnChange: (data: any) => void;
    handleBusinessNatureChange: (data: string) => void;
    handleMeetingAssignedToChange : (data: string) => void;
    leadInfoBasicDetails: any;
    selectedAccessTeam: number[] | [];
    userSelected: SelctOptionType[] | [];
    loginData: LoginResponseType;
    finalUserWithLoginUserList:any;
    setUserSelected: React.Dispatch<React.SetStateAction<SelctOptionType[] | []>>
    setSelectedAccessTeam: React.Dispatch<React.SetStateAction<number[] | []>>
    handleTurnOverChange:(data:any)=>void;
}

const LeadInfo = ({
    leadInfo,
    setText,
    fetching,
    finalUserList,
    setoffset,
    limit,
    userSelected,
    loginData,
    finalUserWithLoginUserList,
    setUserSelected,
    setSelectedAccessTeam,
    handleDemoAssignedToChange,
    handleLeadAssignedToChange,
    handleLeadReceivedOnChange,
    setLeadInfoDetails,
    leadInfoBasicDetails,
    handleBusinessNatureChange,
    handleMeetingAssignedToChange,
    handleTurnOverChange
}: AppProps) => {
    const [startDate, setStartDate] = useState<string>("");
    const [followUpdate, setFollowUpdate] = useState<string>("");
    const [leadText, setLeadText] = useState<string>("");
    const [demoText, setDemoText] = useState<string>("");
    const [meetingText,setMeetingText] = useState<string>("")
    const [accessToOthersText, setAccessToOthersText] = useState<string>("");
    useEffect(() => {
        setStartDate(leadInfo?.meetingTimewithDate ? leadInfo?.meetingTimewithDate : "")
    }, [leadInfo?.meetingTimewithDate])

    useEffect(() => {
        setFollowUpdate(leadInfo?.followUpDateWithTime ? leadInfo?.followUpDateWithTime : "")
    }, [leadInfo?.followUpDateWithTime])

    const checkBottom = (e: any) => {
        setoffset((prv: any) => prv + limit);
    };
    const Option = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props} >
                <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                    <CircularAvatar name={data?.label} image={data?.image && data?.image} />
                    {data?.label}
                </div>
            </components.Option>
        );

    };
    const handleMeetingTimeAndDateChange = (date: string) => {
        setLeadInfoDetails((prev: any) => {
            return {
                ...prev,
                leadInfo: {
                    ...prev.leadInfo,
                    meetingTimewithDate: date === "Invalid date" ? null : date
                }
            }
        })
    }

    const handleFollowUpdateAndDateChange = (date: string) => {
        setLeadInfoDetails((prev: any) => {
            return {
                ...prev,
                leadInfo: {
                    ...prev.leadInfo,
                    followUpDateWithTime: date === "Invalid date" ? null : date
                }
            }
        })
    }

    const handleChange = (e: any) => {
        let accessTeamIdName: any = e?.map((e: any) => {
            return e?.value;
        });

        let totalUser = e?.map((e: any) => {
            return {
                value: e?.value,
                label: e?.label,
            };
        });
        setUserSelected(totalUser);
        setSelectedAccessTeam(accessTeamIdName);
    };

    return (
        <>
            <div className='row ml-2'>
                <div className="col-md-3">
                    <label className='mb-1' htmlFor="Lead Received On">Lead Received On</label>
                    <div className="form-group">
                        <div className="date-picker-wraper mr-0">
                            <Label className='m-0 p-0 w-100'>
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={leadInfo?.leadReceivedOn ? new Date(moment(`${leadInfo?.leadReceivedOn}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { handleLeadReceivedOnChange?.(moment(e).format('YYYY-MM-DD')) }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name='meetingTimewithDate'
                                    placeholderText='Choose date'
                                    className='form-control'
                                />
                                <span className="calender-icon" style={{ right: '25px', cursor: 'pointer', marginTop: "22px" }}>
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mt-1">
                    <label htmlFor="businessNature">Business Nature</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="businessNature"
                            value={leadInfoBasicDetails?.businessNature}
                            onChange={(e) => handleBusinessNatureChange(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div>
            <div className='row ml-2'  style={{width:"98%"}}>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Lead Assigned To'>Lead Assigned To</label>
                    <Select
                        options={finalUserList}
                        value={leadInfo?.leadAssignedTo}
                        components={{ Option }}
                        onChange={handleLeadAssignedToChange}
                        isSearchable={true}
                        isLoading={fetching && leadText?.length > 0}
                        onMenuClose={() => setoffset(0)}
                        onMenuScrollToBottom={(e: any) => checkBottom(e)}
                        onInputChange={(e) => {
                            setText(e)
                            setLeadText(e)
                        }}
                    />
                </div>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Demo Assigned To'>Demo Assigned To</label>
                    <Select
                        options={finalUserList}
                        value={leadInfo?.demoAssignedTo}
                        components={{ Option }}
                        onChange={handleDemoAssignedToChange}
                        isSearchable={true}
                        isLoading={fetching && demoText?.length > 0}
                        onMenuClose={() => setoffset(0)}
                        onMenuScrollToBottom={(e: any) => checkBottom(e)}
                        onInputChange={(e) => {
                            setText(e)
                            setDemoText(e)
                        }}
                    />
                </div>

                <div className='col-md-3'>
                    <label htmlFor='Meeting Assigned To'>Meeting Assigned To</label>
                    <Select
                        options={finalUserWithLoginUserList}
                        value={leadInfo?.meetingAssignedTo}
                        components={{ Option }}
                        onChange={handleMeetingAssignedToChange}
                        isSearchable={true}
                        isLoading={fetching&&meetingText?.length>0}
                        onMenuClose={() => setoffset(0)}
                        onMenuScrollToBottom={(e: any) => checkBottom(e)}
                        onInputChange={(e)=>{setText(e)
                            setMeetingText(e)}}
                    />
                </div>

                <div className='col-md-3'>
                    <label className='mb-1'>
                        Access to team members
                    </label>
                    <Select
                        className="dropdown"
                        placeholder={<div style={{color:"hsl(0, 0%, 20%)"}}>Select..</div>} 
                        value={userSelected[0]?.label ? userSelected?.filter((e: any) => e?.value !== loginData?.user_id) : []}
                        options={finalUserList}
                        onChange={handleChange}
                        isMulti
                        isClearable
                        components={{ Option }}
                        isLoading={fetching && accessToOthersText?.length > 0}
                        isSearchable={true}
                        onMenuScrollToBottom={(e: any) => checkBottom(e)}
                        onInputChange={(e: string) => {
                            setText(e);
                            setAccessToOthersText(e);
                            setoffset(0);
                        }}
                    />
                </div>
                
            </div>

            <div className='row ml-2'  style={{width:"98%"}}>
            <div className="col-md-3">
                    <label className='mb-1' htmlFor="meetingTimewithDate">Meeting Time with Date</label>
                    <div className="form-group">
                        <div className="date-picker-wraper mr-0 lead-date-picker">
                            <Label className="m-0 p-0 w-100">
                                <DatePicker
                                    selected={
                                        leadInfo?.meetingTimewithDate
                                            ? new Date(
                                                moment(
                                                    `${leadInfo?.meetingTimewithDate}T00:00:00`,
                                                    "YYYY-MM-DD, HH:mm"
                                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                                            )
                                            : null
                                    }
                                    onChange={(e: any) => {
                                        handleMeetingTimeAndDateChange(
                                            moment(e).format("YYYY-MM-DD, HH:mm")
                                        );
                                    }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name="dateOfInvoice"
                                    placeholderText="Choose date"
                                    className="form-control"
                                    showTimeSelect
                                    minDate={new Date()}
                                    value={startDate}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                />
                                <span
                                    className="calender-icon mt-3"
                                    style={{ top: "15px", right: "25px", cursor: "pointer" }}
                                >
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Turn Over'>Turnover (in crores)</label>
                    <div  >
                        <input
                            type='number'
                            name='turnOver'
                            className='form-control'
                            value={leadInfoBasicDetails?.turnOver}
                            onChange={handleTurnOverChange}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label className='mb-1' htmlFor="followUpdateWithTime">Follow-Up Time with Date</label>
                    <div className="form-group">
                        <div className="date-picker-wraper mr-0 lead-date-picker">
                            <Label className="m-0 p-0 w-100">
                                <DatePicker
                                    selected={
                                        leadInfo?.followUpDateWithTime
                                            ? new Date(
                                                moment(
                                                    `${leadInfo?.followUpDateWithTime}T00:00:00`,
                                                    "YYYY-MM-DD, HH:mm"
                                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                                            )
                                            : null
                                    }
                                    onChange={(e: any) => {
                                        handleFollowUpdateAndDateChange(
                                            moment(e).format("YYYY-MM-DD, HH:mm")
                                        );
                                    }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name="followUpdateWithTime"
                                    placeholderText="Choose date"
                                    className="form-control"
                                    showTimeSelect
                                    minDate={new Date()}
                                    value={followUpdate}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                />
                                <span
                                    className="calender-icon mt-3"
                                    style={{ top: "15px", right: "25px", cursor: "pointer" }}
                                >
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            
        </>
    )
}

export default LeadInfo